import { Directive, TemplateRef, ViewContainerRef, computed, effect, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { UserPermission } from '../models/user-permission.enum';
import { PermissionService } from '../services/permission.service';

@Directive({
  selector: '[hasPermission]',
  standalone: true
})
export class HasPermissionDirective {
  readonly hasPermission = input<UserPermission[]>([]);

  private readonly templateRef = inject(TemplateRef);
  private readonly viewContainerRef = inject(ViewContainerRef);
  private readonly permissionService = inject(PermissionService);

  private readonly permissions$ = toSignal(this.permissionService.permissions$, { initialValue: [] });

  private readonly canShow$ = computed(() => {
    const permissions = this.hasPermission();

    if (!permissions.length) {
      return false;
    }

    const userPermissions = this.permissions$();

    return permissions.some((permission) => userPermissions.includes(permission));
  });

  constructor() {
    effect(() => {
      if (this.canShow$()) {
        if (this.viewContainerRef.length === 0) {
          this.viewContainerRef.createEmbeddedView(this.templateRef);
        }
      } else {
        this.viewContainerRef.clear();
      }
    });
  }
}
